document.addEventListener('DOMContentLoaded', function () {
    // Form Success Mode Logic
    var form = document.querySelector('form.webflow_form');
    if (form) {

        const applyIframeParams = function () {
            if (!form.hasAttribute('data-iframe-form')) {
                return;
            }

            const params = new URLSearchParams(window.location.search);
            form.querySelectorAll('[data-iframe-param]').forEach(function (field) {
                const paramName = field.getAttribute('data-iframe-param');
                const paramValue = paramName ? params.get(paramName) : null;
                if (!paramValue) {
                    return;
                }

                if (field.type === 'radio' || field.type === 'checkbox') {
                    field.checked = field.value === paramValue;
                    return;
                }

                field.value = field.type === 'email' ? paramValue.toLowerCase() : paramValue;
                field.dispatchEvent(new Event('change', { bubbles: true }));
            });
        };

        applyIframeParams();

        const applyStoredUtmParams = function () {
            const pageParams = new URLSearchParams(window.location.search);
            const storedParamsString = localStorage.getItem('urlParams');
            const parsedStoredParams = storedParamsString ? new URLSearchParams(storedParamsString) : null;
            const utmMap = {
                utm_source: 'utm_source_webflow_ann',
                utm_medium: 'utm_medium_webflow_ann',
                utm_campaign: 'utm_campaign_webflow_ann'
            };
            const formTitleField = form.querySelector('input[name="form_title_webflow_ann"]');
            let insertionPoint = formTitleField;
            Object.keys(utmMap).forEach(function (utmKey) {
                const utmValue = pageParams.get(utmKey) || parsedStoredParams?.get(utmKey);
                if (!utmValue) {
                    return;
                }
                const fieldName = utmMap[utmKey];
                const existingField = form.querySelector('input[name="' + fieldName + '"]');
                if (existingField) {
                    existingField.value = utmValue;
                    return;
                }
                const hiddenField = document.createElement('input');
                hiddenField.type = 'hidden';
                hiddenField.name = fieldName;
                hiddenField.value = utmValue;
                if (insertionPoint && insertionPoint.parentNode) {
                    insertionPoint.insertAdjacentElement('afterend', hiddenField);
                    insertionPoint = hiddenField;
                } else {
                    form.appendChild(hiddenField);
                }
            });
        };
        applyStoredUtmParams();
        const submitButtonInvalidId = document.querySelector('input[type="submit"].invalid-id');
        if (submitButtonInvalidId) {
            const popup = document.createElement('div');
            popup.style.cssText = 'position: absolute; top: 100%; left: 0; background: white; padding: 2rem; border-radius: .4rem; box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 3px; z-index: 10002; max-width: 300px; margin-top: 0.5rem;';
            popup.innerHTML = '<p style="font-size: 1.25rem; color: #333;">No associated record was found. Please ensure that you are utilizing the link provided to update your record.</p>';
            submitButtonInvalidId.parentNode.style.position = 'relative';
            submitButtonInvalidId.parentNode.insertBefore(popup, submitButtonInvalidId.nextSibling);

            const radios = form.querySelectorAll('input[type="radio"]');
            radios.forEach(radio => {
                radio.disabled = true;
            });
        }

        var formRouting = form.querySelector('input[name="form_routing_method_webflow_ann"]')?.value || form.getAttribute('data-routing') || null;
        // console.log('Form Routing:', formRouting);
        var formTitle = form.querySelector('input[name="form_title_webflow_ann"]')?.value || '';
        // console.log('Form Title:', formTitle);

        var phoneInput = form.querySelector('input[type="text"][name="phone_number_webflow_ann"]');
        if (phoneInput) {
            phoneInput.addEventListener('input', function (e) {
                let value = e.target.value.replace(/\D/g, '');
                if (value.length > 10) value = value.slice(0, 10);
                if (value.length >= 6) {
                    e.target.value = '(' + value.slice(0, 3) + ') ' + value.slice(3, 6) + '-' + value.slice(6);
                } else if (value.length >= 3) {
                    e.target.value = '(' + value.slice(0, 3) + ') ' + value.slice(3);
                } else if (value.length > 0) {
                    e.target.value = '(' + value;
                } else {
                    e.target.value = value;
                }
            });
        }

        var successMode = form.getAttribute('data-success');
        var successHandle = '';
        if (successMode === 'redirect') {
            successHandle = form.getAttribute('data-success-route') || '';
            // console.log('Success Mode:', successMode);
            // console.log('Success Route:', successHandle);
        } else if (successMode === 'message') {
            successHandle = form.getAttribute('data-success-message') || '';
            // console.log('Success Mode:', successMode);
            // console.log('Success Message:', successHandle);
        }
        var formSourceUrl = document.querySelector('input[name="form_source_url_webflow_ann"]');
        if (formSourceUrl) {
            var sourceUrl = new URL(window.location.href);
            if (!sourceUrl.search) {
                var storedParams = localStorage.getItem('urlParams');
                if (storedParams) {
                    sourceUrl.search = storedParams.startsWith('?') ? storedParams.slice(1) : storedParams;
                }
            }
            formSourceUrl.value = sourceUrl.href;
            // console.log('Updated form_source_url_webflow_ann:', formSourceUrl.value);
        }
        var brandName = document.querySelector('input[name="brand_name_webflow_ann"]');
        if (brandName) {
            // console.log('Brand Name:', brandName.value);
        }
        var selects = form.querySelectorAll('select');
        selects.forEach(function (select) {
            select.addEventListener('change', function () {
                var selectedOption = select.options[select.selectedIndex];
                if (selectedOption && !selectedOption.disabled && select.selectedIndex !== 0) {
                    select.classList.add('valid-selection-made');
                } else {
                    select.classList.remove('valid-selection-made');
                }
            });
        });
        var dateInputs = form.querySelectorAll('input[type="date"]');
        dateInputs.forEach(function (dateInput) {
            dateInput.addEventListener('change', function () {
                if (dateInput.value && new Date(dateInput.value) instanceof Date && !isNaN(new Date(dateInput.value))) {
                    dateInput.classList.add('valid-selection-made');
                } else {
                    dateInput.classList.remove('valid-selection-made');
                }
            });
        });
        var radios = form.querySelectorAll('input[type="radio"]');
        radios.forEach(function (radio) {
            radio.addEventListener('change', function () {
                var radioGroup = form.querySelectorAll('input[type="radio"][name="' + radio.name + '"]');
                radioGroup.forEach(function (r) {
                    var label = r.closest('label');
                    if (label) {
                        label.classList.remove('selected-radio');
                    }
                });
                var label = radio.closest('label');
                if (label) {
                    label.classList.add('selected-radio');
                }
            });
        });

        var loanTypeRadios = form.querySelectorAll('input[type="radio"][name="loan_type_webflow_ann"]');
        loanTypeRadios.forEach(function (radio) {
            radio.addEventListener('change', function () {
                if (radio.checked) {
                    // console.log('Loan Type selected:', radio.value);

                    const prospectPropertyFieldset = form.querySelector('fieldset[data-fieldset="prospect_property"]');
                    const legend = prospectPropertyFieldset?.querySelector('legend');

                    if (radio.value === 'Cash-Out Refinance' || radio.value === 'NoCash-Out Refinance') {
                        if (legend) {
                            legend.textContent = 'Please include your current property information.';
                        }
                    } else {
                        if (legend) {
                            legend.textContent = 'Please include information about the property you are looking at.';
                        }
                    }
                }
            });
        });

        var qualifyingSelect = form.querySelector('select[name="qualifying_webflow_ann"]');
        if (qualifyingSelect) {
            qualifyingSelect.addEventListener('change', function () {
                // console.log('Qualifying selection changed:', qualifyingSelect.value);
                form.querySelectorAll('[data-c2kmatch]').forEach(elem => {
                    elem.setAttribute('data-cash2keys', 'default');
                });

                const prospectPropertyFieldset = form.querySelector('fieldset[data-fieldset="prospect_property"][data-c2kmatch="new"]');
                if (prospectPropertyFieldset && qualifyingSelect.value !== 'general_info_inquiry') {
                    prospectPropertyFieldset.setAttribute('data-cash2keys', 'yes');
                }

                const legend = form.querySelector('fieldset[data-fieldset="prospect_property"] legend');
                if (qualifyingSelect.value === 'buy_now_sell_later_inquiry' || qualifyingSelect.value === 'cash_bridge_inquiry') {
                    if (legend) {
                        legend.textContent = 'Please include your current property information.';
                    }
                } else {
                    if (legend) {
                        legend.textContent = 'Please include information about the property you are looking at.';
                    }
                }
                const additionalInfoField = form.querySelector('input[type="hidden"][name="additional_info_webflow_ann"]');
                if (additionalInfoField) {
                    additionalInfoField.value = qualifyingSelect.options[qualifyingSelect.selectedIndex].textContent;
                }
            });
        }

        var loSelect = form.querySelector('select[name="lo_select"]');
        if (loSelect) {
            loSelect.addEventListener('change', function (event) {
                var selected = loSelect.options[loSelect.selectedIndex];
                if (!selected) return;
                var assignField = form.querySelector('input[name="assigned_user_id_webflow_ann"]');
                var costField = form.querySelector('input[name="cost_center_webflow_ann"]');
                var emailField = form.querySelector('input[name="lo_email_address_webflow_ann"]');
                var totalExpertId = selected.getAttribute('data-totalexpertid');
                if (assignField && totalExpertId && totalExpertId.trim() !== '0') assignField.value = totalExpertId;
                if (costField) costField.value = selected.getAttribute('data-cost_center') || '';
                if (emailField) emailField.value = (selected.getAttribute('data-email_address') || '').toLowerCase();
                var originatorElem = form.querySelector('[data-reference="originator-selection-defined"]');
                var loHeadshotElem = form.querySelector('[data-reference="lo-headshot"]');
                var loNameElem = form.querySelector('[data-reference="lo-name"]');
                var loNmlsElem = form.querySelector('[data-reference="lo-nmls"]');
                var headshotRef = selected.getAttribute('data-headshot_ref') || '';
                // console.log('Headshot Ref:', headshotRef);
                if (originatorElem && originatorElem.style.display === "none") {
                    originatorElem.style.removeProperty('display');
                }
                if (loNameElem) {
                    loNameElem.textContent = selected.textContent.trim();
                }
                if (loHeadshotElem) {
                    loHeadshotElem.innerHTML = '';
                    if (headshotRef) {
                        const img = document.createElement('img');
                        img.src = 'https://annie-mac.com' + headshotRef;
                        img.alt = selected.textContent.trim();
                        img.loading = 'lazy';
                        loHeadshotElem.appendChild(img);
                        // console.log('Headshot image src:', img.src);
                    }
                }
                if (loNmlsElem) {
                    const nmls = selected.getAttribute('data-nmls') || '';
                    loNmlsElem.textContent = nmls ? `NMLS# ${nmls}` : '';
                }
            });
        }
        else if (form.getAttribute('data-reaction') === 'true') {
            // Form Reaction Assignment Logic
            var loanOfficerData = JSON.parse(localStorage.getItem('loanOfficerData'));
            var expectedSlug = localStorage.getItem('loanOfficerExpectedSlug');
            var hash = window.location.hash;
            var hashSlug = null;
            if (hash && hash.startsWith('#lo=')) {
                hashSlug = hash.replace('#lo=', '').split('&')[0];
            }
            if (hashSlug && expectedSlug && hashSlug !== expectedSlug) {
                // console.log('Hash slug', hashSlug, 'differs from expectedSlug', expectedSlug, '- fetching new LO data.');
                if (typeof fetchLO_data === 'function') {
                    fetchLO_data(hashSlug);
                    // Wait for localStorage to update, then reload the form
                    const checkLOData = setInterval(function () {
                        var newExpectedSlug = localStorage.getItem('loanOfficerExpectedSlug');
                        if (newExpectedSlug === hashSlug && localStorage.getItem('loanOfficerData')) {
                            clearInterval(checkLOData);
                            window.location.reload();
                        }
                    }, 50);
                    // Fallback: after 2s, reload anyway
                    setTimeout(function () {
                        clearInterval(checkLOData);
                        window.location.reload();
                    }, 2000);
                }
            }
            if (form.getAttribute('data-reaction') === 'true' && loanOfficerData) {
                // Populating LO name, NMLS and headshot clone from canvas into data-references.
                var loNameElem = document.querySelector('[data-reference="lo-name"]');
                var loNmlsElem = document.querySelector('[data-reference="lo-nmls"]');
                var loHeadshotElem = document.querySelector('[data-reference="lo-headshot"]');
                // console.log('loanOfficerData:', loanOfficerData);
                const loAddedTitle = loanOfficerData.fields?.added_title || '';
                const loDisplayName = [loanOfficerData.fields?.pno_first_name, loanOfficerData.fields?.pno_last_name, loAddedTitle].filter(Boolean).join(' ');
                if (loNameElem && loDisplayName) {
                    loNameElem.textContent = loDisplayName;
                    // console.log('Set loNameElem:', loNameElem.textContent);
                }
                if (loNmlsElem && loanOfficerData.fields?.pno_nmls) {
                    loNmlsElem.textContent = 'NMLS# ' + loanOfficerData.fields.pno_nmls;
                    // console.log('Set loNmlsElem:', loNmlsElem.textContent);
                }

                addOriginatorLink();


                const propertyStateSelect = form.querySelector('select[name="property_state_webflow_ann"]');
                if (propertyStateSelect && loanOfficerData.fields?.pno_licensed_in_states) {
                    const licensedStates = loanOfficerData.fields.pno_licensed_in_states.split(',').map(s => s.trim().toUpperCase());
                    const loFirstName = loanOfficerData.fields?.pno_first_name || 'This LO';
                    const options = propertyStateSelect.querySelectorAll('option');

                    options.forEach(option => {
                        if (option.value === '' || option.value === 'Undecided') return;

                        if (licensedStates.includes(option.value)) {
                            option.disabled = false;
                        } else {
                            option.disabled = true;
                            option.textContent = `${loFirstName} is not licensed in ${option.textContent}`;
                        }
                    });

                    // console.log('Licensed states:', licensedStates);
                }
                if (loHeadshotElem) {
                    const headshotUrl = loanOfficerData.headshot;
                    if (headshotUrl) {
                        const img = document.createElement('img');
                        img.src = headshotUrl;
                        img.alt = loDisplayName + " Headshot";
                        img.loading = 'lazy';
                        loHeadshotElem.appendChild(img);
                    }
                }

                var originalLeadAssignment = document.querySelector('input[name="assigned_user_id_webflow_ann"]')?.value || '';
                var originalCostCenter = document.querySelector('input[name="cost_center_webflow_ann"]')?.value || '';
                var originalEmailAddress = document.querySelector('input[name="lo_email_address_webflow_ann"]')?.value || '';
                var originalCrmRouting = document.querySelector('input[name="crm_routing_webflow_ann"]')?.value || '';
                var totalExpertId = loanOfficerData.fields?.pno_totalexpertid;
                var costCenter = loanOfficerData.fields?.pno_cost_center || originalCostCenter;
                var crmRouting = loanOfficerData.fields?.pno_tmpshapeinstanceid || originalCrmRouting;
                var emailAddress = (loanOfficerData.fields?.pno_email || originalEmailAddress).toLowerCase();
                if (totalExpertId !== null && totalExpertId !== undefined && String(totalExpertId).trim() !== '' && String(totalExpertId).trim() !== '0') {
                    document.querySelector('input[name="assigned_user_id_webflow_ann"]').value = totalExpertId;
                }
                document.querySelector('input[name="cost_center_webflow_ann"]').value = costCenter;
                document.querySelector('input[name="lo_email_address_webflow_ann"]').value = emailAddress;
            } else {
                // console.log('No loanOfficerData found in localStorage or data-reaction is not true.');
                // If no loanOfficerData and URL contains #lo=, ensure association is made before reload
                const hash = window.location.hash;
                if (hash && hash.startsWith('#lo=')) {
                    if (!sessionStorage.getItem('loReloaded')) {
                        const slug = hash.replace('#lo=', '').split('&')[0];
                        if (slug) {
                            // console.log('No loanOfficerData found, URL contains #lo=, calling fetchLO_data("' + slug + '") to associate before reload.');
                            if (typeof fetchLO_data === 'function') {
                                fetchLO_data(slug);
                                // Wait for localStorage to be set, then reload
                                const checkLOData = setInterval(function () {
                                    if (localStorage.getItem('loanOfficerData')) {
                                        clearInterval(checkLOData);
                                        sessionStorage.setItem('loReloaded', '1');
                                        window.location.reload();
                                    }
                                }, 50);
                                // Fallback: if not set after 2s, reload anyway
                                setTimeout(function () {
                                    if (!localStorage.getItem('loanOfficerData')) {
                                        clearInterval(checkLOData);
                                        sessionStorage.setItem('loReloaded', '1');
                                        window.location.reload();
                                    }
                                }, 2000);
                            } else {
                                // fetchLO_data not available, just reload
                                sessionStorage.setItem('loReloaded', '1');
                                window.location.reload();
                            }
                        }
                    } else {
                        // console.log('Page already reloaded once for #lo=, not reloading again.');
                    }
                }
                const loanOriginatorDiv = document.querySelector('div.loan-originator-details');
                if (loanOriginatorDiv) {
                    loanOriginatorDiv.innerHTML = '<a href="#" style="color: var(--colour-primary); font-weight: 800;" onclick="fetchAndDisplayLOPopup(); return false;">Working with an originator?</a>';
                }
            }
        }
    }

    // Lead Update Logic
    var updateOnly = form.getAttribute('data-update');
    if (updateOnly !== 'False') {
        var leadId = document.querySelector('input[name="lead_id_webflow_ann"]')?.value || '';
        // var shapeInstance = document.querySelector('input[name=""]')?.value || '';
        var campaignDialogue = form.querySelector('input[type="radio"][name="campaign_dialogue_webflow_ann"]:checked')?.value || '';
        // console.log('Lead ID found:', leadId);
        // console.log('Shape Instance found:', shapeInstance);
        // console.log('Campaign Dialogue found:', campaignDialogue);
        if (updateOnly === 'TCPA') {
            // console.log('TCPA update mode enabled');
            var tcpaRadios = form.querySelectorAll('input[type="radio"][name="tcpa_selection_webflow_ann"]');
            tcpaRadios.forEach(function (radio) {
                radio.addEventListener('change', function () {
                    var tcpaTimestampField = form.querySelector('input[name="tcpa_timestamp_webflow_ann"]');
                    if (tcpaTimestampField && radio.checked) {
                        var now = new Date();
                        var pad = function (n) { return n < 10 ? '0' + n : n; };
                        var formatted = pad(now.getMonth() + 1) + '/' +
                            pad(now.getDate()) + '/' +
                            now.getFullYear() + ' ' +
                            pad(now.getHours()) + ':' +
                            pad(now.getMinutes()) + ':' +
                            pad(now.getSeconds());
                        tcpaTimestampField.value = formatted;
                    }
                });
            });
        }
        if (updateOnly === 'Contact') {
            var emailParam = new URLSearchParams(window.location.search).get('email_address');
            if (emailParam) {
                var emailField = form.querySelector('input[name="email_address_webflow_ann"]');
                if (emailField) {
                    emailField.value = emailParam.toLowerCase();
                }
            }
        }
        if (updateOnly === 'True') {
            // console.log('True update mode enabled');
            var campaignDialogueParam = new URLSearchParams(window.location.search).get('campaign_dialogue');
            if (campaignDialogueParam) {
                var campaignDialogueRadio = form.querySelector(`input[type="radio"][name="campaign_dialogue_webflow_ann"][value="${campaignDialogueParam}"]`);
                if (campaignDialogueRadio) {
                    campaignDialogueRadio.checked = true;
                    var label = campaignDialogueRadio.closest('label');
                    if (label) {
                        label.classList.add('selected-radio');
                    }
                }
            }
        }
    }

    if (!window.location.pathname.includes('/response/text-opt-in/')) {
        var tcpaRadios = form.querySelectorAll('input[name="tcpa_selection_webflow_ann"]');
        if (tcpaRadios.length > 0) {
            tcpaRadios.forEach(function (tcpaRadio) {
                tcpaRadio.addEventListener('change', function () {
                    var tcpaTimestampFields = form.querySelectorAll('input[name="tcpa_timestamp_webflow_ann"]');
                    if (!tcpaRadio.checked) {
                        tcpaTimestampFields.forEach(function (tcpaTimestampField) {
                            tcpaTimestampField.value = '';
                        });
                        return;
                    }
                    tcpaTimestampFields.forEach(function (tcpaTimestampField) {
                        var now = new Date();
                        var pad = function (n) { return n < 10 ? '0' + n : n; };
                        tcpaTimestampField.value = pad(now.getMonth() + 1) + '/' +
                            pad(now.getDate()) + '/' +
                            now.getFullYear() + ' ' +
                            pad(now.getHours()) + ':' +
                            pad(now.getMinutes()) + ':' +
                            pad(now.getSeconds());
                    });
                });
            });
        }
    }

    const sessionStorageKey = 'formData_' + window.location.pathname;
    const excludedStorageFields = [
        'property_state_webflow_ann',
        'tcpa_selection_webflow_ann'
    ];
    const savedFormData = sessionStorage.getItem(sessionStorageKey);
    if (savedFormData) {
        try {
            const formDataObj = JSON.parse(savedFormData);
            Object.keys(formDataObj).forEach(fieldName => {
                if (excludedStorageFields.includes(fieldName)) return;
                const fields = form.querySelectorAll(`[name="${fieldName}"]`);
                fields.forEach(field => {
                    if (field.type === 'radio' || field.type === 'checkbox') {
                        if (field.value === formDataObj[fieldName]) {
                            field.checked = true;
                            if (field.type === 'radio') {
                                const label = field.closest('label');
                                if (label) {
                                    label.classList.add('selected-radio');
                                }
                            }
                        }
                    } else {
                        field.value = formDataObj[fieldName];
                        if (fieldName === 'lo_select') {
                            field.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    }
                });
            });
        } catch (e) {
            // console.log('Error restoring form data from session storage:', e);
        }
    }

    const allFormFields = form.querySelectorAll('input, select, textarea');
    allFormFields.forEach(field => {
        const saveFieldToSession = () => {
            if (excludedStorageFields.includes(field.name)) return;
            const currentFormData = sessionStorage.getItem(sessionStorageKey);
            const formDataObj = currentFormData ? JSON.parse(currentFormData) : {};

            if (field.type === 'radio' || field.type === 'checkbox') {
                if (field.checked) {
                    formDataObj[field.name] = field.value;
                }
            } else {
                formDataObj[field.name] = field.value;
            }

            sessionStorage.setItem(sessionStorageKey, JSON.stringify(formDataObj));
        };

        field.addEventListener('change', saveFieldToSession);
        field.addEventListener('input', saveFieldToSession);
    });

    // Form Submit Logic, Conditional on Success Mode
    const submitButton = document.querySelector('button[type="submit"][data-handle="form_handler"], input[type="submit"][data-handle="form_handler"]');
    if (submitButton) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            var additionalInfoInput = form.querySelector('input[name="additional_info_webflow_ann"]');
            if (additionalInfoInput && additionalInfoInput.getAttribute('data-note') === 'True') {
                // console.log('Notes functionality for backend management is true');
            }

            // Validate required fields
            const requiredFields = form.querySelectorAll('[required]');
            let isValid = true;
            requiredFields.forEach(field => {
                if (!field.value || field.value.trim() === '') {
                    isValid = false;
                    field.classList.add('error');
                } else {
                    field.classList.remove('error');
                }
            });

            if (!isValid) {
                // alert('Please fill in all required fields.');
                return;
            }

            submitButton.disabled = true;

            const formData = new FormData(form);
            const rawData = Object.fromEntries(formData);
            const data = Object.entries(rawData).reduce((cleaned, [key, value]) => {
                if (typeof value === 'string') {
                    const trimmedValue = value.trim();
                    if (trimmedValue !== '') {
                        cleaned[key] = trimmedValue;
                    }
                    return cleaned;
                }

                if (value !== null && value !== undefined && value !== '') {
                    cleaned[key] = value;
                }

                return cleaned;
            }, {});
            const payload = JSON.stringify(data);
            // console.log('Form submit payload JSON:', payload);
            const successMessageTarget = form.querySelector('[data-form-success-message], .w-form-done, .form-submit-message');

            fetch('/wp-json/custom/v1/form_submit_handler/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: payload
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.text().then(text => {
                        const body = (text || '').trim();
                        // console.log('Form submit response body (attempted JSON parse):', body);
                        if (!body) {
                            return null;
                        }

                        try {
                            return JSON.parse(body);
                        } catch (parseError) {
                            console.warn('Form submit response was not JSON; continuing with success mode handling.');
                            return null;
                        }
                    });
                })
                .then(responseData => {
                    if (responseData && responseData.success === false) {
                        throw new Error(responseData.message || 'Form submission failed');
                    }

                    clearSavedFormData();

                    if (successMode === 'redirect' && successHandle) {
                        const redirectRoute = (responseData && responseData.redirect_url) || successHandle;
                        window.location.href = redirectRoute;
                    }
                    else if (successMode === 'message' && successHandle) {
                        const successMessage = (responseData && responseData.message) || successHandle;
                        if (successMessageTarget) {
                            successMessageTarget.innerHTML = successMessage;
                        }
                    } else {
                        if (successMessageTarget) {
                            successMessageTarget.innerHTML = 'Submission complete!';
                        }
                        setTimeout(function () {
                            window.location.href = '/';
                        }, 2000);
                    }
                    submitButton.disabled = false;
                })
                .catch(error => {
                    console.error('Form submission error:', error);
                    alert("There's been an issue.")
                    const activeOverlay = document.querySelector('.form-submit-overlay, .lo-search-dialog-overlay, .lo-notice-dialog-overlay');
                    if (activeOverlay) {
                        activeOverlay.style.opacity = '0';
                        setTimeout(() => activeOverlay.remove(), 300);
                    }
                    const activeSubmitDialog = document.querySelector('.form-submit-dialog');
                    if (activeSubmitDialog) {
                        activeSubmitDialog.remove();
                    }
                    document.body.style.overflow = 'auto';
                    submitButton.disabled = false;
                });
        });
    }
});


function clearSavedFormData() {
    sessionStorage.removeItem('formData_' + window.location.pathname);
}

// Add "Not right? Find your originator." link to originator-details
function addOriginatorLink() {
    const originatorDetailsDivs = document.querySelectorAll('div.originator-details');
    if (!originatorDetailsDivs.length) {
        return;
    }

    originatorDetailsDivs.forEach(function (originatorDetailsDiv) {
        const scopedContainer = originatorDetailsDiv.closest('form, .modular_form_handle, .loan-originator-details') || document;
        const originatorNmlsSpan = scopedContainer.querySelector('span.originator-nmls[data-reference="lo-nmls"]');
        if (!originatorNmlsSpan || originatorNmlsSpan.innerText.trim() === '') {
            return;
        }

        if (originatorDetailsDiv.querySelector('a.lo_switch_trigger_toggle')) {
            return;
        }

        const findOriginatorLink = document.createElement('a');
        findOriginatorLink.href = '#';
        findOriginatorLink.textContent = 'Not right? Find your originator.';
        findOriginatorLink.classList.add('lo_switch_trigger_toggle');

        // Click handler to fetch LO posts and display in modal
        findOriginatorLink.addEventListener('click', function (e) {
            e.preventDefault();
            fetchAndDisplayLOPopup();
        });

        originatorDetailsDiv.appendChild(findOriginatorLink);
    });
}

const loUiStyles = {
    overlay: 'position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(15,23,42,0.55);display:flex;justify-content:center;align-items:center;z-index:10020;padding:24px;',
    dialog: 'background-color:#ffffff;border-radius:12px;max-width:520px;width:100%;padding:24px;box-shadow:0 24px 60px rgba(15,23,42,0.22);border:1px solid #e2e8f0;',
    heading: 'margin:0 0 8px;font-size:24px;line-height:1.2;color:#0f172a;',
    bodyText: 'margin:0 0 16px;font-size:14px;line-height:1.5;color:#334155;',
    input: 'width:100%;padding:12px 14px;border:1px solid #cbd5e1;border-radius:8px;font-size:16px;line-height:1.4;outline:none;color:#0f172a;background:#ffffff;',
    errorText: 'min-height:18px;margin:10px 0 0;font-size:13px;color:#b00020;',
    controls: 'display:flex;justify-content:flex-end;gap:10px;margin-top:18px;',
    secondaryButton: 'border:1px solid #cbd5e1;background:#ffffff;color:#0f172a;padding:10px 14px;border-radius:8px;cursor:pointer;font-weight:600;',
    primaryButton: 'border:none;background:#0a4d9e;color:#ffffff;padding:10px 16px;border-radius:8px;cursor:pointer;font-weight:600;',
    modalContent: 'position:relative;background-color:#ffffff;border-radius:12px;padding:24px;max-width:600px;width:90%;max-height:80vh;overflow-y:auto;box-shadow:0 24px 60px rgba(15,23,42,0.22);border:1px solid #e2e8f0;',
    closeButton: 'position:absolute;top:12px;right:12px;width:36px;height:36px;font-size:24px;line-height:1;border:none;border-radius:8px;background:#f8fafc;color:#0f172a;cursor:pointer;',
    listContainer: 'display:flex;flex-direction:column;gap:12px;',
    listItem: 'display:flex;align-items:center;gap:14px;padding:14px;border:1px solid #dbe4f0;border-radius:10px;cursor:pointer;transition:background-color 0.2s ease,border-color 0.2s ease;',
    listItemHover: '#f1f5ff',
    headshot: 'width:50px;height:50px;border-radius:50%;object-fit:cover;border:1px solid #dbe4f0;',
    name: 'font-weight:700;font-size:16px;line-height:1.4;color:#0f172a;margin-bottom:4px;',
    nmls: 'font-size:14px;line-height:1.4;color:#475569;'
};

function openLOSearchDialog() {
    return new Promise((resolve) => {
        const overlay = document.createElement('div');
        overlay.className = 'lo-search-dialog-overlay';
        overlay.style.cssText = loUiStyles.overlay;

        const dialog = document.createElement('div');
        dialog.className = 'lo-search-dialog';
        dialog.style.cssText = loUiStyles.dialog;

        const heading = document.createElement('h3');
        heading.textContent = 'Find Your Originator';
        heading.style.cssText = loUiStyles.heading;

        const description = document.createElement('p');
        description.textContent = 'Enter your loan officer name or NMLS number.';
        description.style.cssText = loUiStyles.bodyText;

        const input = document.createElement('input');
        input.type = 'text';
        input.placeholder = 'Name or NMLS';
        input.style.cssText = loUiStyles.input;

        const errorText = document.createElement('p');
        errorText.style.cssText = loUiStyles.errorText;

        const controls = document.createElement('div');
        controls.style.cssText = loUiStyles.controls;

        const cancelBtn = document.createElement('button');
        cancelBtn.type = 'button';
        cancelBtn.textContent = 'Cancel';
        cancelBtn.style.cssText = loUiStyles.secondaryButton;

        const searchBtn = document.createElement('button');
        searchBtn.type = 'button';
        searchBtn.textContent = 'Search';
        searchBtn.style.cssText = loUiStyles.primaryButton;

        const closeDialog = (value) => {
            document.removeEventListener('keydown', onKeyDown);
            overlay.remove();
            resolve(value);
        };

        const submitDialog = () => {
            const value = input.value.trim();
            if (!value) {
                errorText.textContent = 'Please enter a loan officer name or NMLS number.';
                input.focus();
                return;
            }
            closeDialog(value);
        };

        const onKeyDown = (event) => {
            if (event.key === 'Escape') {
                closeDialog(null);
            }
            if (event.key === 'Enter') {
                event.preventDefault();
                submitDialog();
            }
        };

        cancelBtn.addEventListener('click', () => closeDialog(null));
        searchBtn.addEventListener('click', submitDialog);
        overlay.addEventListener('click', (event) => {
            if (event.target === overlay) {
                closeDialog(null);
            }
        });
        input.addEventListener('input', () => {
            errorText.textContent = '';
        });

        controls.appendChild(cancelBtn);
        controls.appendChild(searchBtn);
        dialog.appendChild(heading);
        dialog.appendChild(description);
        dialog.appendChild(input);
        dialog.appendChild(errorText);
        dialog.appendChild(controls);
        overlay.appendChild(dialog);
        document.body.appendChild(overlay);

        document.addEventListener('keydown', onKeyDown);
        setTimeout(() => input.focus(), 0);
    });
}

function openLONoticeDialog(message) {
    const overlay = document.createElement('div');
    overlay.className = 'lo-notice-dialog-overlay';
    overlay.style.zIndex = '99999 !important';

    const dialog = document.createElement('div');
    dialog.className = 'lo-notice-dialog';

    const heading = document.createElement('h3');
    heading.className = 'lo-notice-heading';
    heading.textContent = 'Search Results';

    const body = document.createElement('p');
    body.className = 'lo-notice-body';
    body.textContent = message;

    const okBtn = document.createElement('button');
    okBtn.className = 'lo-notice-ok-btn';
    okBtn.type = 'button';
    okBtn.textContent = 'OK';

    const viewAllBtn = document.createElement('button');
    viewAllBtn.className = 'lo-notice-view-all-btn';
    viewAllBtn.type = 'button';
    viewAllBtn.textContent = 'View All';

    const controls = document.createElement('div');
    controls.className = 'lo-notice-controls';

    const closeDialog = () => {
        document.removeEventListener('keydown', onKeyDown);
        overlay.remove();
    };

    const onKeyDown = (event) => {
        if (event.key === 'Escape' || event.key === 'Enter') {
            event.preventDefault();
            closeDialog();
        }
    };

    okBtn.addEventListener('click', closeDialog);
    viewAllBtn.addEventListener('click', () => {
        closeDialog();
        window.location.href = '/loan-officers/';
    });
    overlay.addEventListener('click', (event) => {
        if (event.target === overlay) {
            closeDialog();
        }
    });

    controls.appendChild(viewAllBtn);
    controls.appendChild(okBtn);
    dialog.appendChild(heading);
    dialog.appendChild(body);
    dialog.appendChild(controls);
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);
    document.addEventListener('keydown', onKeyDown);
    okBtn.focus();
}

// Fetch LO posts and display in modal popup
function fetchAndDisplayLOPopup() {
    const isC2KPage = window.location.pathname.includes('/cash2keys');
    const modularForm = isC2KPage ? document.getElementById('modular-form-container') : null;
    const modularFormWasVisible = modularForm && modularForm.style.display !== 'none';
    if (modularFormWasVisible) {
        modularForm.style.display = 'none';
    }

    const restoreModularForm = () => {
        if (modularFormWasVisible && modularForm) {
            modularForm.style.display = '';
        }
    };

    openLOSearchDialog().then((query) => {
        if (query === null) {
            restoreModularForm();
            return;
        }

        const { listContainer, closeModal } = displayLOModal(null, restoreModularForm);

        const loadingEl = document.createElement('div');
        loadingEl.className = 'lo-modal-loading';
        loadingEl.style.cssText = 'padding:32px 16px;text-align:center;color:#475569;font-size:15px;';
        loadingEl.textContent = 'Searching\u2026';
        listContainer.appendChild(loadingEl);

        fetch('/wp-json/custom/v1/pull-all-lo/?query=' + encodeURIComponent(query))
            .then(response => response.json())
            .then(data => {
                listContainer.innerHTML = '';
                if (data.success && data.lo_posts && data.lo_posts.length) {
                    _fillLOModalList(data.lo_posts, listContainer);
                } else {
                    console.error('Failed to fetch LO posts:', data.message);
                    closeModal();
                    openLONoticeDialog('No loan officers matched your search.');
                }
            })
            .catch(error => {
                console.error('Error fetching LO posts:', error);
                closeModal();
                openLONoticeDialog('Unable to search loan officers right now.');
            });
    });
}

// Display LO posts in modal popup.
// When loPosts is null, creates the modal shell and returns { modal, listContainer, closeModal }.
// When loPosts is provided, also populates the list immediately.
function displayLOModal(loPosts, onClose) {
    // Create modal container
    const modal = document.createElement('div');
    modal.id = 'loModal';
    modal.className = 'lo-modal';
    modal.style.zIndex = '99999 !important';

    // Create modal content
    const modalContent = document.createElement('div');
    modalContent.className = 'lo-modal-content';

    // Create close button
    const closeBtn = document.createElement('button');
    closeBtn.className = 'lo-modal-close-btn';
    closeBtn.textContent = '×';

    // Create title
    const title = document.createElement('h2');
    title.className = 'lo-modal-title';
    title.textContent = 'Select an Originator';

    // Create list container
    const listContainer = document.createElement('div');
    listContainer.className = 'lo-modal-list-container';

    modalContent.appendChild(closeBtn);
    modalContent.appendChild(title);
    modalContent.appendChild(listContainer);
    modal.appendChild(modalContent);
    document.body.appendChild(modal);

    const closeModal = () => {
        document.removeEventListener('keydown', onModalKeyDown);
        modal.remove();
        if (typeof onClose === 'function') onClose();
    };

    const onModalKeyDown = (event) => {
        const key = String(event.key || '').toLowerCase();
        if (key === 'escape' || key === 'esc' || event.keyCode === 27) {
            event.preventDefault();
            closeModal();
        }
    };

    closeBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', (e) => {
        if (e.target === modal) closeModal();
    });

    document.addEventListener('keydown', onModalKeyDown);

    if (loPosts) {
        _fillLOModalList(loPosts, listContainer);
    }

    return { modal, listContainer, closeModal };
}

function _fillLOModalList(loPosts, listContainer) {
    const hashMatch = window.location.hash.match(/#lo=([^&]+)/i);
    const currentHashSlug = hashMatch ? decodeURIComponent(hashMatch[1]).trim() : '';

    const resolveLoSlug = (lo) => {
        if (lo.slug) {
            return String(lo.slug).trim();
        }

        if (lo.permalink) {
            try {
                const permalinkUrl = new URL(lo.permalink, window.location.origin);
                const pathParts = permalinkUrl.pathname.split('/').filter(Boolean);
                return pathParts[pathParts.length - 1] || '';
            } catch (error) {
                console.error('Invalid LO permalink:', lo.permalink, error);
            }
        }

        return '';
    };

    loPosts.forEach(lo => {
        const resolvedSlug = resolveLoSlug(lo);
        if (currentHashSlug && resolvedSlug && resolvedSlug === currentHashSlug) {
            return;
        }

        const loItem = document.createElement('div');
        loItem.className = 'lo-modal-list-item';
        loItem.addEventListener('mouseenter', () => {
            loItem.classList.add('is-hover');
        });
        loItem.addEventListener('mouseleave', () => loItem.classList.remove('is-hover'));

        const headshotWrapper = document.createElement('div');
        const categoryClass = String(lo.category || '')
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9_-]+/g, '-');
        headshotWrapper.className = 'originator-headshot staff-headshot-display-container smaller-headshot' + (categoryClass ? ' ' + categoryClass + '-branded-headshot' : '');
        headshotWrapper.setAttribute('data-reference', 'lo-headshot');

        if (lo.headshot && String(lo.headshot).trim() !== '') {
            const headshot = document.createElement('img');
            headshot.className = 'lo-modal-headshot-image';
            headshot.src = lo.headshot;
            headshot.alt = lo.title + ' Headshot';
            headshotWrapper.appendChild(headshot);
        }

        // Info container
        const infoContainer = document.createElement('div');
        infoContainer.className = 'lo-modal-info-container';

        const nameElement = document.createElement('div');
        nameElement.className = 'lo-modal-name';
        nameElement.textContent = lo.title;

        const nmlsElement = document.createElement('div');
        nmlsElement.className = 'lo-modal-nmls';
        nmlsElement.textContent = 'NMLS: ' + lo.fields;

        infoContainer.appendChild(nameElement);
        infoContainer.appendChild(nmlsElement);

        loItem.appendChild(headshotWrapper);
        loItem.appendChild(infoContainer);
        loItem.addEventListener('click', () => {
            if (!resolvedSlug) {
                console.error('Unable to resolve LO slug for hash replacement.');
                return;
            }

            const newHash = 'lo=' + encodeURIComponent(resolvedSlug);

            if (window.location.hash === '#' + newHash) {
                window.location.reload();
                return;
            }

            window.location.hash = newHash;
            window.location.reload();
        });

        listContainer.appendChild(loItem);
    });
}
